import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Label } from './styles';
import { useWorkstations } from '@/hooks/v1';
import { SelectWithCreation } from '@/components/ui/Inputs';
import { hierarchyHandler } from '@/utils/hierarchy-handler';
import { HierarchiesField } from '@/utils/enum';

const { useFormInstance, useWatch } = Form;

export function Workstations() {
	const form = useFormInstance();

	const sectorId = useWatch(HierarchiesField.SECTOR, form);
	const companyId = useWatch(HierarchiesField.COMPANY, form);
	const organizationId = useWatch(HierarchiesField.ORGANIZATION, form);

	const title = I18n.get('Workstation');
	const fieldName = HierarchiesField.WORKSTATION;

	const {
		data: workstations,
		isFetching: isGettingWorkstations,
		isError: errorGettingWorkstations
	} = useWorkstations({
		organization_id: organizationId,
		company_id: companyId,
		sector_id: sectorId
	});

	function handleSelectWorkstation(id: string): void {
		const fieldsToReset = hierarchyHandler.getHierarchiesFieldsToClear(fieldName);

		if (fieldsToReset && id) {
			form.resetFields(fieldsToReset);
			form.setFieldValue(fieldName, id);
		}
	}

	function handleClearWorkstation(): void {
		const fieldsToReset = hierarchyHandler.getHierarchiesFieldsToClear(fieldName);
		fieldsToReset && form.resetFields(fieldsToReset);
	}

	return (
		<Form.Item name={fieldName} label={<Label>{title}</Label>}>
			<SelectWithCreation
				showSearch
				allowClear
				placeholder={title}
				selectOptions={workstations}
				loading={isGettingWorkstations}
				onClear={handleClearWorkstation}
				onChange={handleSelectWorkstation}
				disabled={!sectorId || !workstations || errorGettingWorkstations}
			/>
		</Form.Item>
	);
}
